export default __webpack_public_path__ + "static/media/thrift_savings_plan_light.647d23ad.png";